import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

/**
 * Icon + message + explanation + optional action — never just blank space.
 * docs/DESIGN_SYSTEM.md §4.15.
 */
export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center text-center py-16 px-6">
      <Icon size={32} className="text-text-tertiary mb-4" aria-hidden="true" />
      <p className="text-h3 text-text-primary">{title}</p>
      {description ? (
        <p className="text-small text-text-secondary mt-2 max-w-sm">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
